export const BASE_DOMAIN = 'microcms.io';
export const BASE_MANAGEMENT_DOMAIN = 'microcms-management.io';
export const API_VERSION_1 = 'v1';
export const API_VERSION_2 = 'v2';
export const MAX_RETRY_COUNT = 2;
export const MIN_TIMEOUT_MS = 5000;
